Apt.fn.make('series', {
	/**
	 * Initialize module
	 */
	init: function() {
		this.filters = Apt.fn.filters().init('series', {
			source: 'api/v1/series',
			view: 'series.results',
			filters: $.get('filters'),
			query: {
				room: $.get('room')
			}
		});
	},

	/**
	 * Unload module
	 */
	unload: function() {
		this.filters.$destroy();
	}
});